module.exports = __webpack_public_path__ + "img/district.8e2bcb08.svg";